import { render, staticRenderFns } from "./ColorEditor.vue?vue&type=template&id=c6f73ca6&"
import script from "./ColorEditor.vue?vue&type=script&lang=js&"
export * from "./ColorEditor.vue?vue&type=script&lang=js&"
import style0 from "./ColorEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports